import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form} from 'formik';
import * as Yup from 'yup';
import {Modal,Col,Row} from 'react-bootstrap';
import {equipoActions} from '../../../_actions';
import { ErrorMessage, LoadingBoton, TIPO_EQUIPO} from '../../../_helpers';
import Select from 'react-select';

class FormAsignarEquipoUsuario extends React.Component {  

  state = {
    grabando:false,
   };

   setGrabando=(grabando)=>{
    this.setState({grabando:grabando});         
   }

   componentDidMount(){
  }
  
render() {
      const {usuario,misEquipos} =this.props;
          
      let inic={
        id:'',
        equipo: {id:''},
        usuario: {
          id: usuario.id
        }
      }

      let valSchema = {            
      }

      let equiposFinal = misEquipos.filter(it=> !usuario.equipos?.some(itSome=>itSome.id == it.id))

      const validationSchema = Yup.object().shape(valSchema);
      
return(

  <div>
        <Modal show={this.props.show} onHide={()=>this.props.handleClose()} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-recursos text-dark" closeButton>
                <Modal.Title>Asignación de equipo</Modal.Title>
            </Modal.Header> 
            <Modal.Body className="th_recursos">
            <Formik
                enableReinitialize= {true}
                initialValues={inic}
                validationSchema={validationSchema}
                onSubmit={values => {       
                        
                    this.props.asignarEquipo(values,this.props.handleClose,this.setGrabando);
                }}
              >
                {({ errors, touched,values,setFieldValue }) => (
                  <Form>
                     <Row>

                          <Col sm={12}>     
                              <label htmlFor="Estado">
                                  Equipos disponibles                                       
                               </label> <ErrorMessage name={`equipo`} />  
                                <Select
                                    isClearable
                                    value={equiposFinal ? equiposFinal.filter(cam =>cam.id===values.equipo.id) : undefined}
                                    name={`equipo`}
                                    getOptionLabel={option =>`${option.nombre}`}
                                    getOptionValue={option => option.id}
                                    onChange={so =>{
                                        setFieldValue(`equipo`, so?so:{id:''})
                                    }}
                                    isSearchable={true}
                                    placeholder="Seleccione"
                                    options={equiposFinal}
                                />    
                                  
                          </Col>
                      </Row> 
                      <Row className="justify-content-center mt-4 mb-4">
                        <button className="btn btn-link text-secundario cursor mr-3" type="button" onClick={()=>this.props.handleClose()}>
                            Cerrar
                        </button>
                        <button className="btns btns-secundario" type="submit"  disabled={this.state.grabando || values.equipo.id == '' || values.equipo.id == undefined}>
                            Grabar <LoadingBoton grabando={this.state.grabando}/>
                        </button>
                      </Row>
                  </Form>
                )}
              </Formik>


            </Modal.Body>                     
        </Modal> 

  </div>
)};
}

function mapState(state) {
  const { misEquipos } = state.equipos;
  return {misEquipos};
}

const actionCreators = {
  asignarEquipo:equipoActions.asignarEquipo
}

const connectedFormAsignarEquipoUsuario = connect(mapState, actionCreators)(FormAsignarEquipoUsuario);
export { connectedFormAsignarEquipoUsuario as FormAsignarEquipoUsuario };